'use client'

import { clientPage } from '../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/ContributeView').then((m) => ({
    default: m.ContributeView,
  }))
)
